import React from 'react';
import styles from './RaqtaqLoading.module.css'; // Import CSS module for loading styles

const RaqtaqLoading = () => {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loading}></div>
    </div>

  );
};

export default RaqtaqLoading;


// import { useState, useEffect } from "react";
// import Image from "next/image";
// import styles from "./RaqtaqLoading.module.css"; // Import CSS module

// const RaqtaqLoading = () => {
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 2000); // Hide after 2 seconds

//     return () => clearTimeout(timer);
//   }, []);

//   if (!loading) return null; // Remove from DOM when done

//   return (
//     <div className={styles.loaderContainer}>
//       <Image
//         src="https://looybi-images.fra1.cdn.digitaloceanspaces.com/raqtaq-dark-animated.gif" // Make sure the logo is in /public
//         alt="Logo"
//         width={150}
//         height={150}
//         className={styles.logo}
//       />
//     </div>
//   );
// };

// export default RaqtaqLoading;




// import React, { useEffect } from 'react';
// import styles from './RaqtaqLoading.module.css'; // Import CSS module for loading styles

// const RaqtaqLoading = () => {
//   useEffect(() => {
//     const loadingContainer = document.querySelector(`.${styles.loadingContainer}`);

//     // Wait for the animation to complete (2.5 seconds in this case)
//     const timer = setTimeout(() => {
//       if (loadingContainer && loadingContainer.parentNode) {
//         loadingContainer.remove(); // Safely remove the loader from the DOM
//       }
//     }, 2500); // Adjust the time to match your animation duration

//     // Cleanup the timer if the component unmounts
//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <div className={styles.loadingContainer}>
//       <div className={styles.loading}></div>
//     </div>
//   );
// };

// export default RaqtaqLoading;